<template lang="pug">
div
  ValidationProvider(
    v-slot="{ errors }"
    name="phone"
  )
    #phone.form-group.mb-10(:class="{ 'has-error': errors[0] }")
      label.control-label(for="phone")
        | Phone number
      vue-tel-input(
        v-model="phone"
        maxlength="30"
        dynamic-placeholder
        mode="international"
        wrapper-classes="form-control input-default"
        valid-characters-only
      )
      span.help-block {{ errors[0] }}
  ValidationProvider(
    v-slot="{ errors }"
    name="email"
  )
    #email.form-group.mb-10(:class="{ 'has-error': errors[0] }")
      label.control-label(for="email")
        | Email addresses
      AppInput(
        v-model="email"
        placeholder="Add email addresses separated by commas"
        maxlength="250"
      )
      span.help-block {{ errors[0] }}
</template>

<script>
import { mapFormFields } from '~/utils/form_utils';

export default {
  name: 'ClientDialogTabContact',
  computed: {
    ...mapFormFields('client', {
      phone: 'phone',
      email: 'email',
    }),
  },
};
</script>
